class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);

      if (this.hasAttribute('data-gift-product-remove')) {
        // window.giftManager.justRemovedProductGift = this.getAttribute('data-gift-product-remove');
        window.giftManager.justRemovedProductGift = true;
        console.log('Cart Remove Button: Just removed product gift', window.giftManager.justRemovedProductGift);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    if (document.querySelector('.cart-shipping')) {
      this.minSpend = document.querySelector('.cart-shipping').dataset.minSpend;
      // this.minTotal = Math.round(this.minSpend * (Shopify.currency.rate || 1));
      this.minTotal = Math.round(this.minSpend);
      this.cartShipping();
    }

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  cartShipping() {
    let progressPrev = getComputedStyle(document.querySelector('.cart-shipping__progress-current')).getPropertyValue('width');
    document.documentElement.style.setProperty('--progress-prev', progressPrev);

    const shippingElement = document.querySelector('.cart-shipping');
    if (!shippingElement) return;

    this.total = shippingElement.dataset.total;
    if (!this.minTotal) return;

    this.progress = this.total / this.minTotal * 100;
    if (this.progress > 100)
      this.progress = 100;

    // Query elements fresh every time to avoid stale references after section replacement
    const messageDefault = shippingElement.querySelector('.cart-shipping__message_default');
    const messageSuccess = shippingElement.querySelector('.cart-shipping__message_success');

    if (!messageDefault || !messageSuccess) return;

    if (this.minTotal > this.total) {
      let amount = this.minTotal - this.total;
      let messageTemplate = shippingElement.dataset.message;
      if (messageTemplate && typeof formatMoney === 'function') {
        messageTemplate = messageTemplate.trim();
        let message = messageTemplate.replace('||amount||', formatMoney(amount));
        messageDefault.innerText = message;
      }
      messageSuccess.classList.remove('active');
      messageDefault.classList.add('active');
    }
    else {
      messageDefault.classList.remove('active');
      messageSuccess.classList.add('active');
    }

    const progressCurrent = document.querySelector('.cart-shipping__progress-current');
    if (progressCurrent) {
      progressCurrent.style.width = this.progress + '%';
    }
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate(event);
    });

    // Set this CartItems instance on the gift manager for section rendering
    if (window.giftManager) {
      window.giftManager.setCartItems(this);
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate(event) {
    // If we have section data from gift-manager, use it
    if (event && event.source === 'gift-manager' && event.sections && event.sectionsToRender) {
      // Handle empty cart state and shipping updates for gift manager events
      if (event.cartData) {
        const isEmpty = event.cartData.item_count === 0;

        this.classList.toggle('is-empty', isEmpty);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', isEmpty);
      }

      // Update sections using the provided data
      event.sectionsToRender.forEach(section => {
        if (event.sections[section.section]) {
          if (section.id === 'product-gifts') {
            // Handle product-gifts section update specifically 
            const mainCartSection = document.getElementById('main-cart-items');
            const sectionId = mainCartSection ? mainCartSection.dataset.id : 'default';

            const giftModalInfo = document.getElementById('GiftSelectionInfo-' + sectionId) ||
              document.getElementById('GiftSelectionInfo-default') ||
              document.querySelector('[id^="GiftSelectionInfo-"]');

            if (giftModalInfo) {
              // Parse the section HTML and extract the inner content
              const parser = new DOMParser();
              const sectionDoc = parser.parseFromString(event.sections[section.section], 'text/html');
              const sectionElement = sectionDoc.querySelector('.section-product-gifts');

              if (sectionElement) {
                giftModalInfo.innerHTML = sectionElement.innerHTML;
              }
            }
          } else {
            // Handle all other sections (main-cart-items, main-cart-footer, main-cart-shipping, etc.)
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) ||
              document.getElementById(section.id);

            if (elementToReplace && event.sections[section.section]) {
              const parser = new DOMParser();
              const sectionDoc = parser.parseFromString(event.sections[section.section], 'text/html');
              const selectorElement = sectionDoc.querySelector(section.selector);

              if (selectorElement) {
                elementToReplace.innerHTML = selectorElement.innerHTML;
              }
            }
          }
        }
      });

      if (document.querySelector('.cart-shipping')) {
        this.cartShipping();
      }

      if (window.giftManager) {
        window.giftManager.updateProgressBar();
      }
    } else {
      // Fallback to regular section fetch if no section data provided
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-totals'
      },
      {
        id: 'main-cart-shipping',
        section: document.getElementById('main-cart-shipping').dataset.id || null,
        selector: '.js-contents-shipping'
      }
    ];

    // Add product-gifts section if it exists on the cart page
    const productGiftsModal = document.getElementById('GiftSelectionModal');
    if (productGiftsModal) {
      sections.push({
        id: 'product-gifts',
        section: 'product-gifts',
        selector: '.section-product-gifts'
      });
    }

    return sections.filter(section => section.section);
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.querySelectorAll('.quantity__button').forEach((button) => button.classList.add('disabled'));

    if (document.querySelectorAll('.card--product card__add-to-cart button[name="add"]')) {
      document.querySelectorAll('.card--product .card__add-to-cart button[name="add"]').forEach(button => {
        button.setAttribute('aria-disabled', false);
        if (button.querySelector('span')) {
          button.querySelector('span').classList.remove('hidden');
          button.querySelector('.sold-out-message').classList.add('hidden');
        }
      });
    }

    if (document.querySelector('.cart-shipping')) {
      let progressPrev = getComputedStyle(document.querySelector('.cart-shipping__progress-current')).getPropertyValue('width');
      document.documentElement.style.setProperty('--progress-prev', progressPrev);
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          if (section.id === 'product-gifts') {
            // Handle product-gifts section update specifically 
            // The gift modal renders the product-gifts snippet directly, so we need to update the modal content
            const mainCartSection = document.getElementById('main-cart-items');
            const sectionId = mainCartSection ? mainCartSection.dataset.id : 'default';

            const giftModalInfo = document.getElementById('GiftSelectionInfo-' + sectionId) ||
              document.getElementById('GiftSelectionInfo-default') ||
              document.querySelector('[id^="GiftSelectionInfo-"]'); // Fallback to any gift selection info element

            if (giftModalInfo && parsedState.sections[section.section]) {
              // Parse the section HTML and extract the inner content
              const parser = new DOMParser();
              const sectionDoc = parser.parseFromString(parsedState.sections[section.section], 'text/html');
              const sectionElement = sectionDoc.querySelector('.section-product-gifts');

              if (sectionElement) {
                // Get the innerHTML of the section (everything inside .section-product-gifts)
                const newContent = sectionElement.innerHTML;
                giftModalInfo.innerHTML = newContent;
              }
            }
          } else {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.querySelectorAll('.quantity__button').forEach((button) => button.classList.remove('disabled'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.querySelectorAll('.quantity__button').forEach((button) => button.classList.remove('disabled'));
        if (document.querySelector('.cart-shipping')) {
          this.cartShipping();
        }
        this.disableLoading(line);

        // Update gift manager and progress bar
        if (window.giftManager) {
          window.giftManager.updateProgressBar();
        }

        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            if (cart.total_weight > 75000) {
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  attributes: {
                    weight_over_75kg: "true"
                  }
                })
              })
              .then(response => response.json())
              .then(updatedCart => {
                console.log('Updated cart attributes:', updatedCart.attributes);
              });
            } else {
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  attributes: {
                    weight_over_75kg: ""
                  }
                })
              })
              .then(response => response.json())
              .then(updatedCart => {
                console.log('Updated cart attributes:', updatedCart.attributes);
              });
            }
          });
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));


    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
    }
  });
};

document.addEventListener('cart-page-loaded', () => {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.total_weight > 75000) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              weight_over_75kg: "true"
            }
          })
        })
        .then(response => response.json())
        .then(updatedCart => {
          console.log('Updated cart attributes:', updatedCart.attributes);
        });
      } else {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              weight_over_75kg: ""
            }
          })
        })
        .then(response => response.json())
        .then(updatedCart => {
          console.log('Updated cart attributes:', updatedCart.attributes);
        });
      }
    });
});